import React from "react";
import "./TermsOfService.css";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
     const navigate = useNavigate();
      const handleAgree = () => {
    navigate(-1); // 👈 goes back to previous route
  };
  return (
    <div className="jayraj-tos-page">
      {/* Floating background blobs */}
      <div className="jayraj-tos-blob jayraj-tos-blob-pink"></div>
      <div className="jayraj-tos-blob jayraj-tos-blob-blue"></div>

      {/* Glass card */}
      <div className="jayraj-tos-card">
        <h1 className="jayraj-tos-title">Jayraj Group — Terms of Service</h1>
        <h2 className="jayraj-tos-subtitle">For Hotel Booking Services</h2>

        <p>
          Welcome to <strong>Jayraj Group</strong>. By accessing or using our
          hotel booking services, you agree to comply with and be bound by these
          Terms of Service. Please read them carefully before making a booking.
        </p>

        <h3>1. Booking Policy</h3>
        <p>
          All bookings are subject to room availability and confirmation. Once
          confirmed, you will receive a booking reference via email or SMS.
          Customers are responsible for verifying booking details and ensuring
          their accuracy.
        </p>

        <h3>2. Payments</h3>
        <p>
          Full or partial payment must be made at the time of booking depending
          on the selected hotel policy. All payments are processed securely via
          Jayraj Group’s payment partners.
        </p>

        <h3>3. Cancellations & Refunds</h3>
        <p>
          Cancellation requests are subject to the specific hotel’s policy.
          Refunds, if applicable, will be processed within 7–10 business days.
          Non-refundable bookings will not be eligible for any refund.
        </p>

        <h3>4. Guest Responsibilities</h3>
        <p>
          Guests are expected to adhere to the hotel’s rules and regulations.
          Any damage or misconduct will result in penalties or cancellation of
          stay without refund.
        </p>

        <h3>5. Liability</h3>
        <p>
          Jayraj Group acts as an intermediary between the guest and hotel. We
          are not liable for loss, damage, or injury caused by hotel management
          or third-party service providers.
        </p>

        <h3>6. Modifications</h3>
        <p>
          Jayraj Group reserves the right to modify these Terms at any time.
          Continued use of our services implies acceptance of the latest version.
        </p>

        <h3>7. Contact Us</h3>
        <p>
          For any queries regarding these Terms, please contact us at{" "}
          <a href="mailto:support@jayrajgroup.com" className="jayraj-tos-link">
            support@jayrajgroup.com
          </a>
          .
        </p>

        {/* Accept button */}
        <div className="jayraj-tos-button-container">
          <button className="jayraj-tos-btn"  onClick={handleAgree}>I Agree & Continue</button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
